export const PARAMETERS = "PARAMETERS"
export const THEME = "THEME"
export const MAINCOLOR = "MAINCOLOR"